<template>
  <div
    v-if="showOverlay"
    id="overlay"
  >
    <div class="overlay-container">
      <p class="title">{{title}}</p>

      <p class="message" :class="{'line-break': messageWithLineBreaks}">{{message}}</p>

      <p class="close" @click="$emit('close')">OK</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showOverlay: {
      type: Boolean,
      required: true
    },

    title: {
      type: String,
      required: true
    },

    message: {
      type: String,
      required: true
    },

    messageWithLineBreaks: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style scoped>
#overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  @apply z-20;
  overflow-y: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.overlay-container {
  width: 100%;
  margin: 0 20px;
  max-width: 335px;
  background-color: #ffffff;
  padding: 20px;
  border-radius: 10px;
  position: relative;
}

.overlay-container p.title {
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
  margin-bottom: 5px;
}

.overlay-container p.message {
  font-size: 14px;
  line-height: 21px;
}

.overlay-container p.message.line-break {
  white-space: pre-line;
}

.overlay-container p.close {
  margin-top: 20px;
  font-size: 14px;
  line-height: 21px;
  font-weight: 700;
  color: black;
  text-align: right;
  cursor: pointer;
}
</style>
